module.exports = __webpack_public_path__ + "img/icon-espanhol-colorido.ca9c9806.svg";